export default __webpack_public_path__ + "static/media/RS.4bf971be.svg";